export const protocolRegEx = /^(FTP|FTPS|SFTP)$/;
